export const STAFF_LABEL = 'Staff members:'
export const LEADER_LABEL = 'Leader Team members:'
